module.exports = __webpack_public_path__ + "static/media/algo-pasa-pero-no-se-que.f8cf04b9.png";